const useSaveImageToGallery = () => {
  return {
    saveImage: () => console.debug("Not Implemented"),
  };
};

export { useSaveImageToGallery };
